import React, { useState } from 'react';
import pb from '../services/pocketbase';
import { useNavigate, Link } from 'react-router-dom';
import { CITIES } from '../services/cities';
import '../styles/Auth.css';

const SERVICE_CATEGORIES = [
  { value: 'veterinary', label: '🏥 Ветеринар' },
  { value: 'boarding', label: '🏠 Передержка' },
  { value: 'zootaxi', label: '🚗 Зоотакси' },
  { value: 'groomer', label: '✂️ Грумер' },
  { value: 'trainer', label: '🎓 Кинолог' },
];

function Register() {
  const [formData, setFormData] = useState({
    name: '', username: '', email: '', phone: '', password: '', confirmPassword: '', city: '',
    userRole: 'user',
    address: '', workTime: '', priceFrom: '', serviceDescription: '',
    volunteerLink: '',
  });
  const [serviceCategories, setServiceCategories] = useState([]);
  const [agreedToTerms, setAgreedToTerms] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const toggleCategory = (val) => {
    setServiceCategories(prev =>
      prev.includes(val) ? prev.filter(c => c !== val) : [...prev, val]
    );
  };

  const isVolunteer = formData.userRole === 'volunteer';
  const isService = formData.userRole === 'service';

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');
    if (formData.password !== formData.confirmPassword) { setError('Пароли не совпадают'); return; }
    if (formData.password.length < 8) { setError('Пароль должен быть не менее 8 символов'); return; }
    if (isService && serviceCategories.length === 0) { setError('Выберите хотя бы одну категорию услуг'); return; }
    if (isVolunteer && !formData.volunteerLink.trim()) { setError('Укажите ссылку на профиль в соцсети'); return; }
    if (!formData.username.trim()) { setError('Придумайте уникальный @username'); return; }
    if (!/^[a-zA-Z0-9_]{3,20}$/.test(formData.username)) { setError('@username: только латиница, цифры и _, от 3 до 20 символов'); return; }
    if (!agreedToTerms) { setError('Необходимо принять пользовательское соглашение'); return; }
    setLoading(true);
    try {
      // Нормализуем телефон — только цифры
      const normalizedPhone = formData.phone.replace(/\D/g, '');

      // Проверяем дубль по телефону
      if (normalizedPhone.length >= 10) {
        try {
          const existing = await pb.collection('users').getFirstListItem(
            `phone ~ "${normalizedPhone.slice(-10)}"`,
            { fields: 'id' }
          );
          if (existing) {
            setError('Пользователь с таким номером телефона уже зарегистрирован');
            setLoading(false);
            return;
          }
        } catch (e) {
          // getFirstListItem бросает если не найден — это нормально
        }
      }

      const userData = {
        username: formData.username.toLowerCase().trim(),
        email: formData.email,
        password: formData.password,
        passwordConfirm: formData.confirmPassword,
        name: formData.name,
        phone: normalizedPhone ? `+7${normalizedPhone.slice(-10)}` : formData.phone,
        city: formData.city,
        userRole: isVolunteer ? 'volunteer_pending' : formData.userRole,
        postsCount: 0,
        helpCount: 0,
        isVerified: false,
      };
      if (isVolunteer) {
        userData.volunteerLink = formData.volunteerLink;
      }
      if (isService) {
        userData.serviceCategories = JSON.stringify(serviceCategories);
        userData.address = formData.address;
        userData.city = formData.city;
        userData.workTime = formData.workTime;
        userData.priceFrom = formData.priceFrom;
        userData.bio = formData.serviceDescription;
      }
      await pb.collection('users').create(userData);
      await pb.collection('users').authWithPassword(formData.email, formData.password);
      navigate('/home');
    } catch (err) {
      setError(err.message || 'Ошибка регистрации. Попробуйте снова.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-logo">
          <div style={{display:'flex', alignItems:'center', justifyContent:'center', gap:'12px'}}>
            <h1 className="logo-text">AWOO</h1>
            <svg width="40" height="40" viewBox="0 0 512 512" fill="white">
              <path d="M226.5 92.9c14.3 42.9-.3 86.2-32.6 96.8s-70.1-15.6-84.4-58.5s.3-86.2 32.6-96.8s70.1 15.6 84.4 58.5zM100.4 198.6c18.9 32.4 14.3 70.1-10.2 84.1s-59.7-.9-78.5-33.3S-2.7 179.3 21.8 165.3s59.7 .9 78.5 33.3zM69.2 401.2C121.6 259.9 214.7 224 256 224s134.4 35.9 186.8 177.2c3.6 9.7 5.2 20.1 5.2 30.5v1.6c0 25.8-20.9 46.7-46.7 46.7c-11.5 0-22.9-1.4-34-4.2l-88-22c-15.3-3.8-31.3-3.8-46.6 0l-88 22c-11.1 2.8-22.5 4.2-34 4.2C84.9 480 64 459.1 64 433.3v-1.6c0-10.4 1.6-20.8 5.2-30.5zM421.8 282.7c-24.5-14-29.1-51.7-10.2-84.1s54-47.3 78.5-33.3s29.1 51.7 10.2 84.1s-54 47.3-78.5 33.3zM310.1 189.7c-32.3-10.6-46.9-53.9-32.6-96.8s52.1-69.1 84.4-58.5s46.9 53.9 32.6 96.8s-52.1 69.1-84.4 58.5z"/>
            </svg>
          </div>
          <p className="logo-subtitle">Розыск, помощь и уход за животными</p>
        </div>

        <div className="auth-form">
          <h2>Регистрация</h2>
          {error && <div className="error-message">{error}</div>}
          <form onSubmit={handleRegister}>

            <div className="form-group">
              <label>Имя *</label>
              <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Ваше имя или название организации" required disabled={loading} />
            </div>
            <div className="form-group">
              <label>@Username * <span style={{fontSize:'11px', color:'#999', fontWeight:'400'}}>(уникальное имя для поиска)</span></label>
              <div style={{position:'relative'}}>
                <span style={{position:'absolute', left:'12px', top:'50%', transform:'translateY(-50%)', color:'#999', fontSize:'15px', fontWeight:'600'}}>@</span>
                <input type="text" name="username" value={formData.username} onChange={handleChange}
                  placeholder="ivan_petrov" required disabled={loading}
                  style={{paddingLeft:'28px'}}
                  onInput={e => e.target.value = e.target.value.replace(/[^a-zA-Z0-9_]/g, '')}
                />
              </div>
              <div style={{fontSize:'11px', color:'#999', marginTop:'4px'}}>Только латиница, цифры и _ (3–20 символов)</div>
            </div>
            <div className="form-group">
              <label>Email *</label>
              <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="your@email.com" required disabled={loading} />
            </div>
            <div className="form-group">
              <label>Телефон *</label>
              <input type="tel" name="phone" value={formData.phone} onChange={handleChange} placeholder="+7 (___) ___-__-__" required disabled={loading} />
            </div>
            <div className="form-group">
              <label>Город</label>
              <select name="city" value={formData.city} onChange={handleChange} disabled={loading}>
                <option value=''>— Не указан —</option>
                {CITIES.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
              </select>
            </div>

            {/* Тип аккаунта */}
            <div className="form-group">
              <label>Тип аккаунта</label>
              <select name="userRole" value={formData.userRole} onChange={handleChange} disabled={loading}>
                <option value="user">🔍 Потерял / Нашёл</option>
                <option value="volunteer">❤️ Волонтёр</option>
                <option value="service">🛎️ Поставщик услуг</option>
              </select>
            </div>

            {/* Блок волонтёра */}
            {isVolunteer && (
              <div style={{background:'#FFF5F5', border:'2px solid #FFCDD2', borderRadius:'12px', padding:'16px', marginBottom:'16px'}}>
                <div style={{fontSize:'13px', color:'#555', lineHeight:'1.6', marginBottom:'16px', padding:'12px', background:'white', borderRadius:'8px', borderLeft:'3px solid #E8534A'}}>
                  <p style={{margin:'0 0 8px 0'}}>Уважаемые друзья, мы ни сколько не сомневаемся в Ваших благородных стремлениях помогать нашим братьям меньшим, но первоначально новые профили волонтёров будут модерироваться.</p>
                  <p style={{margin:'0 0 8px 0'}}>Поэтому важны любые подтверждающие факты Вашей волонтёрской деятельности — укажите ссылку на Ваш профиль в любой соц. сети или мессенджере.</p>
                  <p style={{margin:'0 0 8px 0'}}>Профиль волонтёра даст Вам дополнительные возможности нашего приложения.</p>
                  <p style={{margin:'0', fontWeight:'700', color:'#E8534A'}}>Огромное Вам спасибо! Проект «AWOO» ❤️</p>
                </div>
                <div className="form-group" style={{marginBottom:0}}>
                  <label>Ссылка на профиль в соцсети / мессенджере *</label>
                  <input
                    type="url"
                    name="volunteerLink"
                    value={formData.volunteerLink}
                    onChange={handleChange}
                    placeholder="https://vk.com/... или t.me/..."
                    required={isVolunteer}
                    disabled={loading}
                  />
                </div>
              </div>
            )}



            {/* Блок для поставщика услуг */}
            {isService && (
              <div style={{background:'#F5F9FF', border:'2px solid #E3F2FD', borderRadius:'12px', padding:'16px', marginBottom:'16px'}}>
                <div style={{fontWeight:'700', fontSize:'14px', color:'#3B5998', marginBottom:'12px'}}>🛎️ Информация об услугах</div>
                <div className="form-group">
                  <label>Категории услуг * <span style={{fontSize:'11px', color:'#999', fontWeight:'400'}}>(можно выбрать несколько)</span></label>
                  <div style={{display:'flex', flexWrap:'wrap', gap:'8px', marginTop:'6px'}}>
                    {SERVICE_CATEGORIES.map(cat => (
                      <button key={cat.value} type="button" onClick={() => toggleCategory(cat.value)} disabled={loading}
                        style={{
                          padding:'8px 12px', borderRadius:'20px', border:'2px solid',
                          borderColor: serviceCategories.includes(cat.value) ? '#3B5998' : '#E0E0E0',
                          background: serviceCategories.includes(cat.value) ? '#E8EDF8' : 'white',
                          color: serviceCategories.includes(cat.value) ? '#3B5998' : '#666',
                          fontWeight: serviceCategories.includes(cat.value) ? '700' : '400',
                          cursor:'pointer', fontSize:'13px', transition:'all 0.2s'
                        }}>
                        {cat.label}
                      </button>
                    ))}
                  </div>
                </div>
                <div className="form-group">
                  <label>Адрес</label>
                  <input type="text" name="address" value={formData.address} onChange={handleChange} placeholder="Улица, дом, город" disabled={loading} />
                </div>
                <div className="form-group">
                  <label>Часы работы</label>
                  <input type="text" name="workTime" value={formData.workTime} onChange={handleChange} placeholder="Например: 09:00 - 21:00" disabled={loading} />
                </div>
                <div className="form-group">
                  <label>Цены от (₽)</label>
                  <input type="text" name="priceFrom" value={formData.priceFrom} onChange={handleChange} placeholder="Например: от 500 ₽" disabled={loading} />
                </div>
                <div className="form-group">
                  <label>Описание услуг</label>
                  <textarea name="serviceDescription" value={formData.serviceDescription} onChange={handleChange}
                    placeholder="Расскажите о ваших услугах..." rows={3} disabled={loading}
                    style={{width:'100%', padding:'10px', border:'1px solid #E0E0E0', borderRadius:'8px', fontSize:'14px', fontFamily:'inherit', resize:'none', boxSizing:'border-box'}} />
                </div>
              </div>
            )}

            <div className="form-group">
              <label>Пароль *</label>
              <input type="password" name="password" value={formData.password} onChange={handleChange} placeholder="Минимум 8 символов" required disabled={loading} />
            </div>
            <div className="form-group">
              <label>Подтвердите пароль *</label>
              <input type="password" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} placeholder="Повторите пароль" required disabled={loading} />
            </div>

            {/* Пользовательское соглашение */}
            <div style={{marginBottom:'16px'}}>
              <div
                onClick={() => setShowTerms(v => !v)}
                style={{display:'flex', alignItems:'center', justifyContent:'space-between',
                  padding:'10px 14px', background:'#F5F5F5', borderRadius:'10px',
                  cursor:'pointer', fontSize:'13px', fontWeight:'600', color:'#555', marginBottom:'8px'}}>
                <span>📄 Пользовательское соглашение</span>
                <span>{showTerms ? '▲' : '▼'}</span>
              </div>
              {showTerms && (
                <div style={{background:'#FAFAFA', border:'1px solid #E0E0E0', borderRadius:'10px',
                  padding:'14px', fontSize:'12px', color:'#555', lineHeight:'1.7',
                  maxHeight:'200px', overflowY:'auto', marginBottom:'10px'}}>
                  <p style={{fontWeight:'700', marginTop:0}}>Пользовательское соглашение сервиса AWOO</p>
                  <p>1. <b>Общие положения.</b> Настоящее Соглашение регулирует использование платформы AWOO (далее — Сервис). Используя Сервис, вы подтверждаете своё согласие с настоящими условиями.</p>
                  <p>2. <b>Статус платформы.</b> AWOO является информационным посредником и не несёт ответственности за содержание объявлений, действия пользователей, волонтёров или поставщиков услуг, а также за результаты поиска животных.</p>
                  <p>3. <b>Ограничение ответственности.</b> Сервис предоставляется «как есть». Администрация AWOO не гарантирует достоверность информации, размещённой пользователями, и не несёт ответственности за любой прямой или косвенный ущерб, возникший в результате использования Сервиса.</p>
                  <p>4. <b>Волонтёры и услуги.</b> Волонтёры и поставщики услуг действуют самостоятельно. AWOO не является работодателем, агентом или поручителем и не несёт ответственности за качество оказанных услуг, действия или бездействие волонтёров.</p>
                  <p>5. <b>Персональные данные.</b> Регистрируясь на платформе, вы даёте согласие на обработку введённых вами персональных данных в целях функционирования Сервиса. Данные не передаются третьим лицам в коммерческих целях.</p>
                  <p>6. <b>Контент пользователей.</b> Пользователь несёт полную ответственность за размещаемые объявления, фотографии и комментарии. Запрещается публикация ложной информации, материалов, нарушающих права третьих лиц или законодательство.</p>
                  <p>7. <b>Изменение условий.</b> Администрация оставляет за собой право изменять условия Соглашения без предварительного уведомления. Продолжение использования Сервиса после внесения изменений означает согласие с новыми условиями.</p>
                  <p style={{marginBottom:0}}>8. <b>Применимое право.</b> Настоящее Соглашение регулируется действующим законодательством. Все споры решаются путём переговоров, а при невозможности — в установленном законом порядке.</p>
                </div>
              )}
              <div
                onClick={() => setAgreedToTerms(v => !v)}
                style={{display:'flex', alignItems:'center', gap:'10px', cursor:'pointer'}}>
                <div style={{
                  width:'20px', height:'20px', borderRadius:'5px', border:'2px solid',
                  flexShrink:0,
                  borderColor: agreedToTerms ? '#3B5998' : '#CCC',
                  background: agreedToTerms ? '#3B5998' : 'white',
                  display:'flex', alignItems:'center', justifyContent:'center'
                }}>
                  {agreedToTerms && <span style={{color:'white', fontSize:'13px', lineHeight:1}}>✓</span>}
                </div>
                <span style={{fontSize:'13px', color:'#555'}}>
                  Я прочитал(а) и принимаю <span style={{color:'#3B5998', fontWeight:'600'}}>пользовательское соглашение</span>
                </span>
              </div>
            </div>

            <button type="submit" className="btn-primary" disabled={loading || !agreedToTerms} style={{opacity: agreedToTerms ? 1 : 0.6}}>
              {loading ? 'Регистрация...' : 'Зарегистрироваться'}
            </button>
          </form>
          <div className="auth-footer">
            <p>Уже есть аккаунт? <Link to="/login">Войти</Link></p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Register;
